import styled from 'styled-components';

export const HeyYabbleCountStepStyle = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
};
